export const SEAL_TEAM = {
  logo: "https://customer-assets.emergentagent.com/job_palmer-hvac-pro/artifacts/2u0we42h_CFCDB172-0D39-4E01-9DD4-8A83B8282693.PNG",
  phoneDisplay: "(479) 900-8804",
  phoneTel: "+14799008804",
  // Background image — attic insulation / ductwork (real Palmer/Seal Team job site)
  heroBg:
    "https://customer-assets.emergentagent.com/job_palmer-hvac-pro/artifacts/5rrg6okw_499930009_1271398854986289_4500475710265033610_n.jpg",
};

export const SEAL_FEATURES = [
  {
    title: "Better Energy Efficiency",
    desc: "Helps reduce heating and cooling loss by sealing gaps and air leaks throughout your building envelope.",
    icon: "Gauge",
  },
  {
    title: "Year-Round Comfort",
    desc: "Keeps indoor temperatures more consistent through hot Arkansas summers and cold winters.",
    icon: "ThermometerSun",
  },
  {
    title: "Air Sealing Power",
    desc: "Expands into cracks, gaps, and hard-to-reach areas for a tighter, more efficient building envelope.",
    icon: "ShieldCheck",
  },
  {
    title: "Great for Homes & Metal Buildings",
    desc: "Ideal for attics, crawlspaces, shops, garages, barns, remodels, and new construction.",
    icon: "Warehouse",
  },
];

export const SEAL_SERVICES = [
  {
    title: "Residential Spray Foam Insulation",
    desc: "Professional residential spray foam insulation for attics, crawlspaces, walls, garages, additions, and remodels.",
    icon: "Home",
  },
  {
    title: "Metal Building Insulation",
    desc: "High-performance metal building insulation for shops, barns, garages, storage buildings, and commercial-style metal structures.",
    icon: "Building2",
  },
  {
    title: "Attic Insulation",
    desc: "Seal the top of your home to reduce heat transfer, lower energy bills, and improve comfort year-round.",
    icon: "MoveUp",
  },
  {
    title: "Crawlspace Insulation",
    desc: "Crawlspace insulation that helps protect your home from drafts, moisture, and uncomfortable floors.",
    icon: "Layers",
  },
  {
    title: "New Construction Insulation",
    desc: "Start your project right with high-performance spray foam insulation installed from the beginning.",
    icon: "Hammer",
  },
  {
    title: "Retrofit & Remodel Insulation",
    desc: "Upgrade older insulation and improve comfort in existing homes, shops, or buildings.",
    icon: "Wrench",
  },
];

export const SEAL_PROCESS = [
  {
    step: "01",
    title: "Request an Estimate",
    desc: "Tell us about your project and what type of building or space needs insulation.",
  },
  {
    step: "02",
    title: "On-Site Evaluation",
    desc: "We inspect the area, measure the space, and recommend the best insulation approach.",
  },
  {
    step: "03",
    title: "Professional Installation",
    desc: "Our team applies spray foam carefully, cleanly, and efficiently — protecting your property at every step.",
  },
  {
    step: "04",
    title: "Final Walkthrough",
    desc: "We review the job, answer your questions, and make sure everything is done right.",
  },
];

export const SEAL_AREAS = [
  "Homes",
  "Attics",
  "Crawlspaces",
  "Garages",
  "Shops",
  "Barns",
  "Metal buildings",
  "Additions",
  "Remodels",
  "New construction",
  "Commercial spaces",
  "Storage buildings",
];
